module.exports = __webpack_public_path__ + "static/img/footer.b959833.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/footer.png
// module id = A4ff
// module chunks = 0